module.exports = __webpack_public_path__ + "static/media/faq_especialistas.7fc289ab.jpg";